export default __webpack_public_path__ + "static/media/sign.e372d4f1.svg";